module.exports = __webpack_public_path__ + "static/media/icon-org-page-opportunity.758760dc.svg";